import { render, staticRenderFns } from "./MiButton.vue?vue&type=template&id=2276cb09&scoped=true"
import script from "@/components/mi/MiButton.ts?vue&type=script&lang=ts&external"
export * from "@/components/mi/MiButton.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/mi/mi-button.scss?vue&type=style&index=0&id=2276cb09&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2276cb09",
  null
  
)

export default component.exports